// Use shared base API for endpoint injection
import { api } from '../middleware/api';

export const stmsupplierApi = api
  .enhanceEndpoints({ addTagTypes: ['Supplier'] })
  .injectEndpoints({
    endpoints: builder => ({
      getSuppliers: builder.query<st_msupplier[], string>({
        query: cid => `supplier/${cid}`,
        providesTags: ['Supplier']
      }),
      getSupplier: builder.query<st_msupplier, string>({
        query: id => `supplier/byid/${id}`
      }),
      insertSupplier: builder.mutation({
        query: supplier => ({
          url: `supplier/`,
          method: 'POST',
          body: supplier
        }),
        invalidatesTags: ['Supplier']
      }),
      updateSupplier: builder.mutation({
        query: supplier => ({
          url: `supplier/`,
          method: 'PUT',
          body: supplier
        }),
        invalidatesTags: ['Supplier']
      }),
      deleteSupplier: builder.mutation({
        query: supplier => ({
          url: `supplier/${supplier.sp_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Supplier']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSuppliersQuery,
  useGetSupplierQuery,
  useInsertSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation
} = stmsupplierApi;

